/* TEN BUT — EPIC-09 / Story 9.2 + EPIC-19 / Story 19.2 — Cookie Consent (GDPR + Consent Mode v2)
 *
 * Asset dedicado (não infla ten-but.js) por separação de responsabilidade e timing/criticidade
 * próprios do consentimento. Padrão herdado dos módulos de ten-but.js: IIFE + guard
 * window.__tbConsentInit + helpers de localStorage + DOMContentLoaded.
 *
 * Responsabilidades:
 *  - Gate de exibição (1ª visita ou bump de POLICY_VERSION) do modal #tb-cookie-consent.
 *  - Modal BLOQUEANTE: trap de foco, scroll travado, SEM dismiss (sem X / ESC / click-outside).
 *  - Acordeão de categorias (funcionais sempre ON; analytics/marketing default OFF).
 *  - 19.2 — primeira camada com DOIS botões de DOIS resultados: reject_all e accept_all.
 *    `accept_selected` mora no fim do acordeão com [hidden] e só é revelado quando algum
 *    interruptor está ligado; com tudo OFF ele repetiria o resultado de reject_all.
 *  - applyConsent(): persiste no localStorage (com versão) + Shopify Customer Privacy API
 *    (setTrackingConsent) + Google Consent Mode v2 (gtag consent update) + eventos de medição.
 *
 * O `gtag('consent','default', denied)` é injetado inline e síncrono no <head> (theme.liquid),
 * antes de content_for_header — este módulo só faz o `update` após a escolha.
 */
(function () {
  if (window.__tbConsentInit) return;
  window.__tbConsentInit = true;

  /* Bump esta versão quando a política/lista de vendors mudar → força re-consent (modal reaparece). */
  var POLICY_VERSION = 1;
  /* Fonte única da versão da política: o gate de consentimento do `tbTrack` (ten-but.js) precisa
     ler a MESMA versão que decide se o banner reaparece. Subir aqui basta para os dois. */
  window.__tbConsentPolicyVersion = POLICY_VERSION;
  var STORAGE_KEY = 'ten_but_cookie_consent';

  function lsGet(key) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function lsSet(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  /* Canal de medição independente do analytics_storage: dataLayer é só um array em memória,
     então o evento sai mesmo de quem recusa analytics (R-7 — evita viés de 100%). */
  function pushDataLayer(payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  /* gtag global é definido pelo stub inline no <head>. Fallback defensivo para o dataLayer. */
  function tbGtag() {
    if (typeof window.gtag === 'function') {
      window.gtag.apply(window, arguments);
    } else {
      pushDataLayer(arguments);
    }
  }

  /* Propaga a escolha para a Shopify Customer Privacy API. A API pode não estar disponível
     imediatamente → carregar via loadFeatures e só então chamar setTrackingConsent.
     Mapeamento (épico): analytics→analytics; marketing→marketing + sale_of_data;
     funcionais→preferences (sempre true). */
  function applyShopifyConsent(state) {
    function set() {
      try {
        if (window.Shopify && window.Shopify.customerPrivacy &&
            typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: state.analytics,
              marketing: state.marketing,
              preferences: true,
              sale_of_data: state.marketing
            },
            function () {}
          );
        }
      } catch (e) {}
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      set();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) { if (!error) set(); }
      );
    }
  }

  /* Google Consent Mode v2 update (defensivo enquanto não há gtag/GTM no tema). */
  function applyConsentMode(state) {
    var ad = state.marketing ? 'granted' : 'denied';
    tbGtag('consent', 'update', {
      analytics_storage: state.analytics ? 'granted' : 'denied',
      ad_storage: ad,
      ad_user_data: ad,
      ad_personalization: ad
    });
  }

  /* O `ten-but.css` (100 KB) carrega ASSÍNCRONO — theme.liquid usa media="print" +
     onload="this.media='all'". Até ele APLICAR, este modal está meio vestido: o critical
     CSS inline só lhe dá posicionamento (fixed/centrado), e todo o resto — padding do
     cartão, tipografia, acordeão, botões — ainda não existe.

     Medido em 2026-09-16, na Home, a 1,6 Mbps / CPU 4x:
       · mostrar o modal antes do CSS aplicar → salto de layout de CLS 0,171, reprodutível
         3/3, com origem em .tb-cookie-consent__modal e __body;
       · mostrá-lo depois → CLS 0.
     Duplicar as ~20 regras de layout do modal no critical CSS inline resolveria o salto
     mas punha esses bytes em TODAS as páginas e criava mais uma cópia para manter em
     sincronia. Esperar é mais barato e não mente.

     Teto de 3 s: se o CSS falhar ou demorar, o banner aparece na mesma. Nunca prender o
     consentimento atrás de um recurso — e note-se que ESPERAR PARA MOSTRAR não grava
     cookie nenhum: nada não-essencial corre antes da escolha, com ou sem este atraso.
     Ver docs/guides/primeiro-load-anonimo.md */
  function whenThemeCssApplied(cb) {
    var link = null;
    var links = document.querySelectorAll('link[href*="ten-but.css"]');
    for (var i = 0; i < links.length; i++) {
      /* O <link> dentro de <noscript> nunca aplica com JavaScript ligado — ignorá-lo. */
      if (!links[i].parentNode || String(links[i].parentNode.nodeName).toLowerCase() !== 'noscript') {
        link = links[i];
        break;
      }
    }
    /* Sem link (ou já aplicado) → mostrar já. É também o caminho de cache quente. */
    if (!link || link.media === 'all') return cb();

    var done = false;
    var poll = null;
    function fire() {
      if (done) return;
      done = true;
      if (poll) clearInterval(poll);
      cb();
    }
    /* O atributo onload do <link> troca media para 'all'; este listener corre depois dele. */
    link.addEventListener('load', function () { setTimeout(fire, 0); });
    /* Se o load já tinha passado antes de chegarmos aqui, o listener nunca dispara. */
    poll = setInterval(function () { if (link.media === 'all') fire(); }, 50);
    setTimeout(fire, 3000);
  }

  function initConsent() {
    var root = document.getElementById('tb-cookie-consent');
    if (!root) return;

    var saved = lsGet(STORAGE_KEY);
    /* Já consentiu nesta versão da política → não exibe nada. */
    if (saved && saved.v === POLICY_VERSION) return;

    var overlay = document.getElementById('tb-cookie-consent-overlay');
    var modal = document.getElementById('tb-cookie-consent-modal');
    var btnAcceptAll = document.getElementById('tb-cookie-accept-all');
    var btnAcceptSelected = document.getElementById('tb-cookie-accept-selected');
    var btnRejectAll = document.getElementById('tb-cookie-reject-all');
    var analyticsInput = document.getElementById('tb-cookie-analytics');
    var marketingInput = document.getElementById('tb-cookie-marketing');
    var lastFocused = document.activeElement;

    function show() {
      root.style.display = 'flex';
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tb-cookie-consent-lock');
      document.body.classList.add('tb-cookie-consent-lock');
      /* Foco inicial no modal.
         ⚠️ `preventScroll: true` é OBRIGATÓRIO aqui, não é micro-otimização.
         `ten-but.css` carrega de forma ASSÍNCRONA (theme.liquid) e é ele que traz
         `.tb-cookie-consent { position: fixed }`. Num primeiro load com cache fria o
         `focus()` corre ANTES desse CSS: o modal ainda é um bloco no fluxo, no fim de
         ~15 000 px de página sem estilo, e o browser rola até ele — de forma ANIMADA,
         porque `base.css:33` tem `scroll-behavior: smooth` global. Resultado medido em
         2026-09-16: a página voava 7 052 px sozinha, à vista da cliente.
         Guardado por `scripts/first-load-guard.js`. Ver docs/guides/primeiro-load-anonimo.md */
      if (modal) modal.focus({ preventScroll: true });
      pushDataLayer({ event: 'cookie_consent_shown', policy_version: POLICY_VERSION });
    }

    function hide() {
      root.style.display = 'none';
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tb-cookie-consent-lock');
      document.body.classList.remove('tb-cookie-consent-lock');
      /* Devolve o foco. `preventScroll` pela mesma razão do `show()`: devolver o foco
         nunca deve arrastar o viewport para onde a pessoa não estava. */
      try { if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true }); } catch (e) {}
    }

    function applyConsent(state, choice) {
      lsSet(STORAGE_KEY, {
        analytics: !!state.analytics,
        marketing: !!state.marketing,
        v: POLICY_VERSION,
        choice: choice,
        ts: Date.now()
      });
      applyShopifyConsent(state);
      applyConsentMode(state);
      /* Notifica consumidores no frame principal (ten-but-clarity.js) sem esperar reload. */
      try {
        document.dispatchEvent(
          new CustomEvent('tb:consent', {
            detail: { analytics: !!state.analytics, marketing: !!state.marketing }
          })
        );
      } catch (e) {}
      /* Genérico de propósito: lê o `choice` que RECEBEU, não uma lista fixa. O ternário antigo
         rotularia qualquer escolha nova (o `reject_all` que chega na 19.2) como accept_selected. */
      pushDataLayer({
        event: 'cookie_consent_' + choice,
        analytics: !!state.analytics,
        marketing: !!state.marketing,
        policy_version: POLICY_VERSION
      });
      /* Story 19.1 (AC-D1..D4): quantas pessoas recusam é o dado que NÃO se obtém depois — por
         isso este evento é a única exceção à fila de consentimento e sai mesmo com analytics
         negado (Consent Mode: ping sem cookie). A 19.2 entra aqui sem tocar neste código: basta
         chamar applyConsent({...}, 'reject_all'). */
      try {
        window.tbTrack('consent_choice', {
          consent_choice: choice,
          analytics: !!state.analytics,
          marketing: !!state.marketing,
          policy_version: POLICY_VERSION
        });
      } catch (e) {}
      hide();
    }

    /* "Recusar todos" — valores LITERAIS, não o estado dos interruptores: quem clica aqui recusa,
       mesmo com um interruptor ligado. `applyConsent` já é genérica (monta o nome do evento por
       'cookie_consent_' + choice e repassa o choice ao tbTrack), então o reject_all sai sem
       nenhuma linha nova lá dentro. */
    if (btnRejectAll) {
      btnRejectAll.addEventListener('click', function () {
        applyConsent({ analytics: false, marketing: false }, 'reject_all');
      });
    }

    /* "Confirmo os selecionados" só existe quando tem resultado próprio: com os dois interruptores
       em OFF ele produziria exatamente o mesmo estado que "Recusar todos" — terceiro botão de
       fachada. O contentor tem aria-live="polite", logo tirar o [hidden] já anuncia; NÃO mexemos
       no foco, que está no interruptor. O trap de foco filtra por offsetParent, então o botão
       escondido fica fora do ciclo do Tab sozinho. */
    function syncAcceptSelected() {
      if (!btnAcceptSelected) return;
      var anyOn = !!((analyticsInput && analyticsInput.checked) || (marketingInput && marketingInput.checked));
      btnAcceptSelected.hidden = !anyOn;
    }

    Array.prototype.forEach.call([analyticsInput, marketingInput], function (input) {
      if (input) input.addEventListener('change', syncAcceptSelected);
    });
    /* Estado inicial explícito: o navegador pode repor `checked` num back/forward cache. */
    syncAcceptSelected();

    /* Acordeão: header expande/colapsa a descrição (+ toggle nas categorias opt-in). */
    var headers = root.querySelectorAll('.tb-cookie-consent__cat-header');
    Array.prototype.forEach.call(headers, function (header) {
      header.addEventListener('click', function () {
        var expanded = header.getAttribute('aria-expanded') === 'true';
        var panelId = header.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        header.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) {
          if (expanded) {
            panel.setAttribute('hidden', '');
          } else {
            panel.removeAttribute('hidden');
          }
        }
      });
    });

    /* "Aceitar todos" — liga analytics + marketing independente dos toggles. */
    if (btnAcceptAll) {
      btnAcceptAll.addEventListener('click', function () {
        applyConsent({ analytics: true, marketing: true }, 'accept_all');
      });
    }

    /* "Aceitar selecionados" — aplica exatamente o estado atual dos toggles (default ambos OFF). */
    if (btnAcceptSelected) {
      btnAcceptSelected.addEventListener('click', function () {
        applyConsent(
          {
            analytics: !!(analyticsInput && analyticsInput.checked),
            marketing: !!(marketingInput && marketingInput.checked)
          },
          'accept_selected'
        );
      });
    }

    /* Trap de foco: Tab circula dentro do modal; ESC é ignorado (modal bloqueante). */
    if (modal) {
      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
          e.preventDefault();
          return;
        }
        if (e.key !== 'Tab' && e.keyCode !== 9) return;

        var focusable = modal.querySelectorAll(
          'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        var visible = Array.prototype.filter.call(focusable, function (el) {
          return el.offsetParent !== null && !el.disabled;
        });
        if (!visible.length) {
          e.preventDefault();
          /* tb-focus-scroll-ok: trap de Tab — só corre por gesto da pessoa, muito depois
             de o CSS aplicar, e aqui rolar para o elemento focado é o comportamento certo
             (o modal tem max-height:90vh + overflow-y:auto). */
          modal.focus();
          return;
        }
        var first = visible[0];
        var last = visible[visible.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus(); /* tb-focus-scroll-ok: trap de Tab, ver acima */
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus(); /* tb-focus-scroll-ok: trap de Tab, ver acima */
        }
      });
    }

    whenThemeCssApplied(show);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConsent);
  } else {
    initConsent();
  }
})();
